import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../CookieAuth/auth.service';
import { Credenciales } from '../interfaces/credenciales';
import { AppService } from '../service/app.service';
import { LoginService } from '../service/login.service';
import { PermisoService } from '../service/permiso.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  cookieValue: string = "";
  email:string="";
  password:string="";
  credenciales:Credenciales={
    email: "",
    passwword: ""};
  alerta:boolean=false;
  constructor(private cookie: AuthService, private login: LoginService, private permisos: PermisoService,private app: AppService) { }

  public async ngOnInit() {
    if(await this.cookie.checkExistCookie()){
      console.log("continua usando app");
      this.cookieValue = this.cookie.getCookie();
      // window.location.href = "/main";
      this.permisos.get(this.cookie.getCookie()).subscribe((data: any[]) => {
        this.app.get().subscribe((app: any[]) => {

          let aplicacion = app.filter(app => app.id === data[0].id_app)[0];
          console.log(aplicacion);
          window.location.href = aplicacion.direccion;
        });

          // window.location.href = data[0].direccion
        });
    }else{
      console.log("no se encontro cockie");
    }
  }

  iniciarSesion(pEmail:string, pPassword:string){
    this.credenciales={
      email: pEmail,
      passwword: pPassword};
      try{
        this.login.iniciarSesion(this.credenciales).subscribe((res)=>{
          if(!!res.token){
           this.cookie.createCookie(pEmail,res.token);
           console.log(res);
           this.permisos.get(this.cookie.getCookie()).subscribe((data: any[]) => {
            this.app.get().subscribe((app: any[]) => {

              let aplicacion = app.filter(app => app.id === data[0].id_app)[0];
              console.log(aplicacion);
              window.location.href = aplicacion.direccion;
            });

              // window.location.href = data[0].direccion
            });
          //  window.location.href = "/sr";
          }else{this.alerta=true;}

       });
      }
      catch(error){
        console.log('Error: no se logueo');
        this.alerta=true;
      }

  }


}
